import { get } from "lodash";
import { useSelector } from "react-redux";

import {
  REQUEST_MASTER_CASESTUDY,
  REQUEST_CREATE_MASTER_CASESTUDY,
  SET_MASTER_CASESTUDY,
  SUCCESS_CREATE_MASTER_CASESTUDY,
  ERROR_GET_MASTER_CASESTUDY,
  ERROR_CREATE_MASTER_CASESTUDY,
  SET_MESSAGE_MASTER_CASESTUDY,
  SUCCESS_DELETE_MASTER_CASESTUDY,
  SUCCESS_UPDATE_MASTER_CASESTUDY,
  REQUEST_DELETE_MASTER_CASESTUDY,
  REQUEST_UPDATE_MASTER_CASESTUDY,
  ERROR_DELETE_MASTER_CASESTUDY,
  ERROR_UPDATE_MASTER_CASESTUDY,
  SET_META_DATA_FOR_PAGINATION,
  SET_SEARCH_TEXT,
} from "./casestudyActionTypes";

interface IState {
  busy: boolean;
  message: string;
  masterCasestudy: any[];
  meta: {
    hasNextPage: boolean;
    total: number;
    limit: number;
    page: number;
    totalPages: number;
  };
  searchText: string;
}

const initialState: IState = {
  busy: false,
  message: "",
  masterCasestudy: [],
  meta: {
    hasNextPage: false,
    limit: 10,
    page: 1,
    total: 10,
    totalPages: 1,
  },
  searchText: "",
};

const casestudy = (state = initialState, action: Record<string, any>) => {
  switch (action.type) {
    case REQUEST_MASTER_CASESTUDY:
    case REQUEST_CREATE_MASTER_CASESTUDY:
    case REQUEST_DELETE_MASTER_CASESTUDY:
    case REQUEST_UPDATE_MASTER_CASESTUDY:
      return {
        ...state,
        busy: true,
        message: "",
      };

    case SET_MESSAGE_MASTER_CASESTUDY:
      return {
        ...state,
        message: "",
      };

    case SET_MASTER_CASESTUDY:
      return {
        ...state,
        busy: false,
        message: "",
        masterCasestudy: Array.isArray(action.payload) ? action.payload : [],
        // masterCasestudy: action.payload,
      };

    case SUCCESS_CREATE_MASTER_CASESTUDY:
      // console.log(action.payload);
      return {
        ...state,
        busy: false,
        message: "",
        masterCasestudy: Array.isArray(state.masterCasestudy)
          ? [...state.masterCasestudy, action.payload]
          : [action.payload],
        // masterCasestudy: [...state.masterCasestudy, action.payload],
      };
    case SUCCESS_DELETE_MASTER_CASESTUDY:
      return {
        ...state,
        busy: false,
        message: "",
        // masterCasestudy: state.masterCasestudy.filter(
        //   (tutorial) => get(tutorial, "_id") !== action.payload
        // ),
        masterCasestudy: Array.isArray(state.masterCasestudy)
          ? state.masterCasestudy.filter(
              (tutorial) => get(tutorial, "_id") !== action.payload
            )
          : [],
      };

    case SUCCESS_UPDATE_MASTER_CASESTUDY:
      return {
        ...state,
        busy: false,
        message: "",
        masterCasestudy: Array.isArray(state.masterCasestudy)
          ? state.masterCasestudy.map((mp) => {
              return get(mp, "_id") === action.payload._id
                ? action.payload
                : mp;
            })
          : action.payload
          ? [action.payload]
          : [],
        // masterCasestudy: state.masterCasestudy.map((mp) => {
        //   return get(mp, "_id") === action.payload._id ? action.payload : mp;
        // }),
      };

    case ERROR_GET_MASTER_CASESTUDY:
    case ERROR_CREATE_MASTER_CASESTUDY:
    case ERROR_UPDATE_MASTER_CASESTUDY:
    case ERROR_DELETE_MASTER_CASESTUDY:
      return {
        ...state,
        busy: false,
        message:
          action.payload || "Something happened wrong try again after sometime",
      };

    case SET_META_DATA_FOR_PAGINATION:
      return {
        ...state,
        busy: false,
        meta: {
          hasNextPage: action.payload.hasNextPage,
          limit: action.payload.limit,
          page: action.payload.page,
          total: action.payload.total,
          totalPages: action.payload.totalPages,
        },
      };

    case SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload,
      };

    default:
      return state;
  }
};

export default casestudy;

export function useCasestudyMaster() {
  return useSelector((state: Record<string, any>) => state.casestudy);
}
